import React, { Component } from 'react'
import './styles.scss'
import Quagga from 'quagga'

// Child component and is called from register cozy component
class BarcodeReader extends Component {
  constructor() {
    super()
    this.state = {
      isCamera: true,
      camera: {
        inputStream: {
          type: 'LiveStream', // From camera
          constraints: {
           width: {min: 640}, // to manage proper aspect ratio so that barcode can be read accurately
            height: {min: 480}, // to manage proper aspect ratio so that barcode can be read accurately
            facingMode: "environment", // Back camera
            aspectRatio: {min: 1, max: 2}
          }
        },
        locator: {
          patchSize: 'large',
          halfSample: true
        },
        numOfWorkers: 4,
        decoder: {
          readers: ['code_39_reader', 'code_128_reader'] // Encoder type
        },
        locate: true,
        multiple: true
      }
    }
    this.initCameraSelection = this.initCameraSelection.bind(this)
    this.attachListeners = this.attachListeners.bind(this)
  }
  // Init barcode read method
  componentWillReceiveProps(np) {
    if (np.startCamera && !this.state.isCamera) {
      this.setState({ isCamera: true })
      this.init()
    } else if (!np.startCamera) {
      this.setState({ isCamera: false })
      Quagga.stop()
    }
  }
  // On page load call init barcode 
  componentDidMount() {
    this.init()
  }

  componentWillUnmount() {
    Quagga.stop()
  }

  attachListeners() {
    let self = this
    self.initCameraSelection()
  }

  // Camera list can be displayed on UI if required from here like back or front
  initCameraSelection() {
    let streamLabel = Quagga.CameraAccess.getActiveStreamLabel()
    return Quagga.CameraAccess.enumerateVideoDevices().then(function(devices) {
      function pruneText(text) {
        return text.length > 30 ? text.substr(0, 30) : text
      }
      var $deviceSelection = document.getElementById('deviceSelection')
      while ($deviceSelection.firstChild) {
        $deviceSelection.removeChild($deviceSelection.firstChild)
      }
      devices.forEach(function(device) {
        var $option = document.createElement('option')
        $option.value = device.deviceId || device.id
        $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)))
        $option.selected = streamLabel === device.label
        $deviceSelection.appendChild($option)
      })
    })
  }
  
  init() {
    let self = this
    Quagga.init(self.state.camera, function(err) {
      if (err) {
        console.log(err)
        return
      }
      self.attachListeners()
      Quagga.start()
    })
    Quagga.onProcessed(function(result) {
      let drawingCtx = Quagga.canvas.ctx.overlay,
        drawingCanvas = Quagga.canvas.dom.overlay

      if (result) {
        // Rectagle box drawing while detecting
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width'), 10), parseInt(drawingCanvas.getAttribute('height'), 10))
          result.boxes
            .filter(function(box) {
              return box !== result.box
            })
            .forEach(function(box) {
              Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 })
            })
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 })
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 })
        }
      }
    })
    // Call parent function once barcode read succesfully
    Quagga.onDetected(function(result) {
      var code = result.codeResult.code
      if (code !== '') {
        self.props.barcodeRead(result.codeResult.code)
      }
    })
  }

  render() {
    return (
      <section id="container">
        <div id="interactive" className="viewport" />
        <div className="controls" style={{ display: 'none' }}>
          <fieldset className="input-group">
            <button className="stop">Stop</button>
          </fieldset>
          <fieldset className="reader-config-group">
            <label>
              <span>Camera</span>
              <select name="input-stream_constraints" id="deviceSelection" />
            </label>
          </fieldset>
        </div>
      </section>
    )
  }
}
export default BarcodeReader



// WEBPACK FOOTER //
// ./src/views/BarcodeReader/component.js